(function($) {
    function syncImageWrapperHeight() {
        if ($(window).width() >= 1280) {
            const $thumbnailWrapper = $('.productView-thumbnail-wrapper');
            const $imageWrapper = $('.productView-image-wrapper');
            if ($thumbnailWrapper.length && $imageWrapper.length) {
                const thumbnailHeight = $thumbnailWrapper.outerHeight();
                $imageWrapper.css({
                    'height': thumbnailHeight + 'px',
                    'overflow-y': 'hidden'
                });
            }
        } else {
            $('.productView-image-wrapper').css({
                'height': '',
                'overflow-y': ''
            });
        }
    }

    $(document).ready(function() {
        syncImageWrapperHeight();
    });

    let resizeTimeout;
    $(window).on('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(syncImageWrapperHeight, 100);
    });
})(jQuery);